module.exports = __webpack_public_path__ + "assets/e4b03c9ec67e815f62219c4bd7f04d0e.png";